<template>
  <div class="text-left w-100" id="studySurvey-page">
    <div class="mt-4 mb-0 mb-md-6 w-100">
      <div class="d-flex align-center w-100">
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
        >
          Voir vos recommandations
        </h1>
      </div>
    </div>

    <!-- Liste des experiences -->
    <div class="mt-4">
      <EatingExperiencePagination />
    </div>
  </div>
</template>

<script>
import EatingExperiencePagination from "./EatingExperiencePagination"

export default {
  name: "EatingExperiencePage",
  components: { EatingExperiencePagination },
}
</script>
